import { styled, Theme } from '@mui/material';

import { themeDefaults } from '@youscience/theme';
import { CoreButton, CoreTypography } from '@youscience/core';

export const sxStyles = {
  cardContentWrap: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  awardType: {
    display: 'flex',
    alignItems: 'center',

    '& > svg:first-of-type': {
      marginRight: '0.625rem',
    },
  },
  donorName: {
    color: themeDefaults?.palette?.text?.secondary,
  },
  description: {
    margin: '1rem 0',
  },
  learnMore: (theme: Theme) => ({
    color: theme.palette.primary.main,
    textDecoration: 'underline',

    '&:hover': {
      cursor: 'pointer',
    },
  }),
  additionalInfo: {
    display: 'flex',

    '& > div:first-of-type': {
      marginRight: '0.75rem',
    },
  },
  additionalInfoItem: {
    display: 'flex',
    alignItems: 'center',

    '& > svg:first-of-type': {
      marginRight: '0.25rem',
    },
  },
  applyBtn: {
    maxWidth: '108px',
    width: '100%',
    height: '32px',
    fontSize: '12px',
  },
  applyStepWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  applyQuestion: {
    fontWeight: 600,
    fontSize: '12px',
  },
  editModeWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  alignCenterWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  selectWrap: {
    width: '220px',
  },
};

export const StyledCardWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isWiderCardType',
})<{ isWiderCardType?: boolean }>(({ isWiderCardType, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxWidth: isWiderCardType ? '624px' : '460px',
  minHeight: '340px',
  width: '100%',
  padding: '1.125rem 1.25rem 0 1.25rem',
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  transition: 'color 0.5s, background-color 0.5s',
  cursor: 'pointer',
}));

export const StyledTopRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: `${theme.spacing(2)} ${theme.spacing(3)}`,

  // Keeps the Utah badge right-aligned when it wraps under the award type
  '& > * + *': {
    marginLeft: 'auto',
  },
}));

export const StyledProgramName = styled(CoreTypography)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordWrap: 'break-word',
  margin: '1.5rem 0',
}));

export const StyledActionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  minHeight: '62px',
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const StyledApplyStepBtn = styled(CoreButton)(() => ({
  display: 'flex',
  minWidth: '66px',
  height: '32px',
  marginLeft: '0.5rem',

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
  },

  '& > p:first-of-type': {
    fontSize: '12px',
  },
}));

export const StyledActionIcon = styled('button')(({ theme }) => ({
  font: 'inherit',
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  marginLeft: '0.5rem',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: theme.palette.grey['50'],
    borderRadius: '5px',
  },
}));

export const StyledFavoriteButton = styled('button')(() => ({
  font: 'inherit',
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'none',
  display: 'flex',
  marginRight: '0.75rem',
  cursor: 'pointer',
}));
